import { render } from "./RuleTutorialView.vue?vue&type=template&id=ca58efd6"
import script from "./RuleTutorialView.vue?vue&type=script&lang=js"
export * from "./RuleTutorialView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__